import { Bell, LogOut } from 'lucide-react'
import type { ReactNode } from 'react'

type AppShellProps = {
  children: ReactNode
  userLabel: string
  title?: string
  subtitle?: string
  onHome: () => void
  onSignOut: () => void
  onOpenProfile: () => void
  onOpenReminders: () => void
  reminderCount: number
  userAvatarUrl?: string
}

function initials(value: string) {
  return value.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase() || 'SA'
}

export function AppShell({ children, userLabel, title, subtitle, onHome, onSignOut, onOpenProfile, onOpenReminders, reminderCount, userAvatarUrl }: AppShellProps) {
  return (
    <div className="app-shell">
      <header className="app-header">
        <button className="brand-button" onClick={onHome} aria-label="Retour au portefeuille">
          <img src="/assets/brand/sablux-ci-logo.png" alt="Sablux Côte d’Ivoire" />
        </button>
        <div className="header-divider" />
        <div className="header-context">
          <strong>{title ?? 'Suivi Aziz'}</strong>
          <span>{subtitle ?? 'Parcours administratifs · Côte d’Ivoire'}</span>
        </div>
        <div className="header-actions">
          <button className="icon-button reminder-button" aria-label={reminderCount ? `${reminderCount} rappel${reminderCount > 1 ? 's' : ''}` : 'Ouvrir les rappels'} title="Rappels" onClick={onOpenReminders} type="button">
            <Bell size={18} />
            {reminderCount ? <span className="reminder-count">{reminderCount > 9 ? '9+' : reminderCount}</span> : null}
          </button>
          <button className="operator" aria-label="Ouvrir mon profil" onClick={onOpenProfile} type="button">
            <div className={`operator-avatar${userAvatarUrl ? ' has-photo' : ''}`}>
              {userAvatarUrl ? <img src={userAvatarUrl} alt={`Photo de profil de ${userLabel}`} /> : initials(userLabel)}
            </div>
            <div>
              <strong>{userLabel}</strong>
              <span>Opérateur administratif</span>
            </div>
          </button>
          <button className="icon-button" aria-label="Se déconnecter" title="Fermer la session sur cet appareil" onClick={onSignOut} type="button">
            <LogOut size={18} />
          </button>
        </div>
      </header>
      {children}
    </div>
  )
}
